import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomLabel from 'designer/component/element/Label'
import PageControl from 'designer/component/control/page/LabelControl'

export const LabelSystem = (props) => (
  <DragElementWrapper {...props}>
    <PageControl {...props} />
  </DragElementWrapper>
)

export const LabelDisplay = (props) => (
  <ElementWrapper {...props}>
    <PageControl {...props} />
  </ElementWrapper>
)

export const labelTester = rankWith(1000, scopeEndsWith('label'))
